import { render, staticRenderFns } from "./CommercialConditions.vue?vue&type=template&id=2db90fc4&"
import script from "./CommercialConditions.vue?vue&type=script&lang=js&"
export * from "./CommercialConditions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports